module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-item dash-poll col-md-4",
    attrs: {
      "id": "poll"
    }
  }, [_c('div', {
    staticClass: "box-header dash-bg-color-skin-light-10"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 header-center"
  }, [_vm._v("\n      " + _vm._s(_vm.app.home[_vm.app.nowLang].poll) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-2 pull-right align-right add-poll-pc cursor-pointer"
  }, [_c('i', {
    staticClass: "fa fa-refresh cursor-pointer",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        _vm.refresh()
      }
    }
  })])]), _vm._v(" "), _c('poll-index', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pollIndexDisp),
      expression: "pollIndexDisp"
    }],
    attrs: {
      "polls": _vm.polls,
      "pollAddChoice": _vm.labels[_vm.app.nowLang].pollAddChoice,
      "pollHistory": _vm.labels[_vm.app.nowLang].pollHistory,
      "collapsed": _vm.collapsed,
      "progressPercent": _vm.progressPercent,
      "nowLang": _vm.app.nowLang,
      "triggerPollInfiniteBool": _vm.triggerPollInfiniteBool,
      "receivedPollsInfiniteLoading": _vm.receivedPollsInfiniteLoading,
      "oldPolls": _vm.oldPolls,
      "receivedOldPollsInfiniteLoading": _vm.receivedOldPollsInfiniteLoading,
      "postChoice": _vm.postChoice,
      "postSelectChoice": _vm.postSelectChoice,
      "triggerResetBool": _vm.triggerResetBool,
      "filePath": _vm.pathImage
    },
    on: {
      "disableTriggerResetBool": function($event) {
        _vm.triggerResetBool = false
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-2 header-left"
  }, [_c('div', {
    staticClass: "rec"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bc46fdb8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/poll/component.vue
// module id = 3967
// module chunks = 1